const apiUrls = require('../../constants/apiUrls');

const storeKey = 'nodeOutage';

const storeDependenciesLegacy = [
    {
        key: 'networkDetails',
        requestProps: [
            {
                path: [
                    'details', 'node'
                ],
                propName: 'node'
            },
            {
                path: [
                    'details', 'marketID'
                ],
                propName: 'marketId'
            }
        ]
    }
];

const storeDependencies = [
    {
        key: 'orderDetails',
        requestProps: [
            {
                path: [
                    'details', 'billingSystem'
                ],
                propName: 'billingSystem'
            },
            {
                path: [
                    'details', 'accountNumber'
                ],
                propName: 'accountNumber'
            }
        ]
    }
];


const nodeOutageLegacyApi = {
    key: storeKey,
    method: 'GET',
    dependencies: storeDependenciesLegacy,
    getApiUrl: (request) => {
        return `${apiUrls.WORKORDER_OUTAGES_LEGACY_URL}?node[]=${request.node.trim()}&marketId[]=${request.marketId}&username[]=fst`;
    }
};

const nodeOutageApi = {
    key: storeKey,
    method: 'GET',
    dependencies: storeDependencies,
    getApiUrl: (request) => {
        return `${apiUrls.WORKORDER_OUTAGES_URL}/details/billingSystem/${request.billingSystem}/accountNumber/${request.accountNumber}`;
    }
};

const nodeOutage = apiUrls.USE_WORKORDER_OUTAGES_LEGACY_API ? nodeOutageLegacyApi : nodeOutageApi;

export default nodeOutage;


// WEBPACK FOOTER //
// ./src/store/order-details-config/nodeOutage.js